// extracted by mini-css-extract-plugin
module.exports = {"rounded":"image_rounded__bqzVV","desktop":"image_desktop__brKdY"};